var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProjectsDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.659,
    height: 100.004,
    viewBox: "0 0 91.659 100.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29734",
    "data-name": "Group 29734",
    transform: "translate(-1115.502 -497.348)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_282",
    "data-name": "Subtraction 282",
    d: "M55.027,100H12.5A12.517,12.517,0,0,1,0,87.494v-75A12.506,12.506,0,0,1,12.5,0H46.238l.016,0a.028.028,0,0,0,.012,0l.039.02h.012a.272.272,0,0,1,.129.02h.047a.573.573,0,0,0,.164.018.03.03,0,0,0,.031.018,4.2,4.2,0,0,1,2.094,1.141l25,25.01a4.1,4.1,0,0,1,1.211,3.146V55.621c-.613-.043-1.234-.066-1.859-.066a25.686,25.686,0,0,0-15.281,5,4.187,4.187,0,0,0-3.7-2.217H20.84a4.166,4.166,0,1,0,0,8.332H51.875A25.875,25.875,0,0,0,55.023,100ZM20.84,41.664a4.167,4.167,0,1,0,0,8.334H54.152a4.167,4.167,0,1,0,0-8.334Zm0-16.648a4.167,4.167,0,1,0,0,8.334h8.32a4.167,4.167,0,1,0,0-8.334ZM50,14.205V20.82a4.175,4.175,0,0,0,4.148,4.2h6.613L50,14.207Z",
    transform: "translate(1115.502 497.348)",
    fill: "#6a5fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_281",
    "data-name": "Subtraction 281",
    d: "M18.508,37.037A18.517,18.517,0,1,1,37.031,18.523,18.531,18.531,0,0,1,18.508,37.037Zm0-21.525A1.285,1.285,0,0,0,17.223,16.8V27.141a1.293,1.293,0,0,0,2.586,0V16.8A1.293,1.293,0,0,0,18.508,15.512Zm0-5.605a1.721,1.721,0,1,0,1.727,1.725A1.722,1.722,0,0,0,18.508,9.906Z",
    transform: "translate(1170.129 560.31)",
    fill: "#6a5fa2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProjectsDark);
export default __webpack_public_path__ + "static/media/noProjectsDark.01b40869eb6e2e4db3dc449022ddf6c1.svg";
export { ForwardRef as ReactComponent };